const ENDPOINT = 'GETtabsearch';
function getTabSearch(gateway, params = {}, customURL = null, customHeaders = null, isKoussa = false) {
    return gateway.get(getTabSearch.endpoint, params, customURL, customHeaders, isKoussa);
}
getTabSearch.endpoint = ENDPOINT;

export { getTabSearch as default };
//# sourceMappingURL=getTabSearch.js.map
